/**
 * FINA-3138 — PostHog kill-switch for the bank-APIs feature (2805).
 *
 * Boolean. Fail-closed (`getExperimentVariant` → false if missing/timeout).
 * Default OFF at release. Target by PostHog group `tenant` = tenantId.
 * The API does not evaluate this flag (no posthog-node). See
 * specs/022-fina-3138-bank-apis-flag/contracts/bank-apis-flag.md
 */
export const BANK_APIS_FLAG = 'bank-apis';

/**
 * Diagnóstico de consola del flag (`[FINA-3138 bank-apis]`). Apagado: el snapshot incluye userId,
 * tenantId, distinctId y parte de la POSTHOG_KEY, y no debe salir en ningún ambiente. Ponerlo en
 * `true` solo en local para diagnosticar y no commitearlo.
 */
export const BANK_APIS_FLAG_DEBUG = false;
